import getCountryFromCoords from './Geolocation';

class LocationService {
  constructor() {
    this.locationPromise = null;
    this.cachedLocation = null;
  }

  async getLocation() {
    if (this.cachedLocation) {
      return this.cachedLocation;
    }

    if (this.locationPromise) {
      return this.locationPromise;
    }

    this.locationPromise = this.fetchLocation();
    return this.locationPromise;
  }

  async fetchLocation() {
    try {
      const position = await new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('Geolocation not supported'));
          return;
        }

        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 300000, // Cache for 5 minutes
          }
        );
      });

      const { latitude, longitude } = position.coords;
      const countryData = await getCountryFromCoords(latitude, longitude);
      
      this.cachedLocation = {
        country: countryData?.country || 'Unknown',
        language: (countryData?.country_code?.trim()?.toLowerCase() === "jp") ? "ja" : "eng"
      };

      // Store in localStorage for future visits
      localStorage.setItem('userLocation', JSON.stringify(this.cachedLocation));
      
      return this.cachedLocation;
    } catch (error) {
      // Check localStorage for cached location
      const cached = localStorage.getItem('userLocation');
      if (cached) {
        try {
          this.cachedLocation = JSON.parse(cached);
          return this.cachedLocation;
        } catch (e) {
          // Invalid cached data, remove it
          localStorage.removeItem('userLocation');
        }
      }

      // Default fallback
      this.cachedLocation = { country: 'Unknown', language: 'eng' };
      return this.cachedLocation;
    }
  }

  getLanguageFromStorage() {
    try {
      const cached = localStorage.getItem('userLocation');
      if (cached) {
        const location = JSON.parse(cached);
        return location.language || 'eng';
      }
    } catch (e) {
      localStorage.removeItem('userLocation');
    }
    return 'eng';
  }
}

export default new LocationService();